import {
  fetchRTPData as fetchRTPDataApi,
  uploadRTPData as uploadRTPDataApi,
} from '../api';

import {
  selectPeriod,
  showAlert,
} from '../../shared/store/actions';
import alertTypes from '../../shared/alertTypes';

import {
  RETURN_TO_PROVISION,
  FETCH_RTP_DATA_SUCCESS,
  FETCH_RTP_DATA_FAILURE,
  UPLOAD_RTP_DATA,
  UPLOAD_RTP_DATA_SUCCESS,
  UPLOAD_RTP_DATA_FAILURE,
} from './types';

export const fetchRTPData = period => async dispatch => {
  const fetchRTPDataSuccess = rtpData => ({
    type: FETCH_RTP_DATA_SUCCESS,
    rtpData,
  });

  try {
    if (!period) {
      return;
    }

    dispatch({
      type: RETURN_TO_PROVISION,
    });

    const periodName = period.name;
    const responseData = await fetchRTPDataApi(periodName);

    return dispatch(fetchRTPDataSuccess(responseData));
  } catch (error) {
    dispatch({
      type: FETCH_RTP_DATA_FAILURE,
    });
  }
};

export const uploadRTPAction = ( taxYear, rtpDetails ) => async dispatch => {
  const UploadRTPDataSuccess = rtpDetails => ({
    type: UPLOAD_RTP_DATA_SUCCESS,
    rtpDetails,
  });

  if (!taxYear || rtpDetails.length === 0) {
    dispatch(showAlert('No Return To Provision(s) are selected.', alertTypes.DANGER));
    dispatch({
      type: UPLOAD_RTP_DATA_FAILURE,
    });
    return;
  }

  try {
    dispatch({
      type: UPLOAD_RTP_DATA,
    });

    const responseData = await uploadRTPDataApi( taxYear, rtpDetails );
    return dispatch(UploadRTPDataSuccess(responseData));
  } catch (error) {
    dispatch({
      type: UPLOAD_RTP_DATA_FAILURE,
    });
  }
};

export const fetchInitialDataForRTPPage = () => async (dispatch, getState) => {
  const { period } = getState().shared;

  dispatch(fetchRTPData( period ));
};

export const selectPeriodForRTP = period => dispatch => {
  dispatch(selectPeriod(period));
  if (!period) {
    return;
  }
  return dispatch(fetchRTPData( period ));
};
